import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, Divider, Typography } from '@mui/material';
import Checkbox from '@sharedCR/common/Checkbox';

import { toggleIsClosedHiddenAction } from 'store/loanApplications/actions';
import { selectIsClosedHidden } from 'store/loanApplications/selectors';

import {
  additionalNavigationContentStyles,
  additionalNavigationTextStyles,
  dividerStyles,
} from './AdditionalComponents.styles';
import { AdditionalComponentsTestIds } from './AdditionalComponents.testIds';

const AdditionalNavigationContent = () => {
  const dispatch = useDispatch();
  const isClosedHidden = useSelector(selectIsClosedHidden);

  const onChange = useCallback(() => dispatch(toggleIsClosedHiddenAction()), [dispatch]);

  return (
    <>
      <Box role="button" sx={additionalNavigationContentStyles} onClick={onChange}>
        <Checkbox
          checked={isClosedHidden}
          data-testid={AdditionalComponentsTestIds.HIDE_CLOSED_LIABILITIES_CHECKBOX}
          size="16"
        />
        <Typography className="truncate" sx={additionalNavigationTextStyles} variant="regular14">
          Hide All Closed Liabilities
        </Typography>
      </Box>
      <Divider sx={dividerStyles} />
    </>
  );
};

export default memo(AdditionalNavigationContent);
